import React, { useEffect, useState, useRef } from "react";
import {
  GoogleMap,
  Circle,
  DrawingManager,
  Polygon,
} from "@react-google-maps/api";
import { useLocation } from "react-router-dom";

const GeofenceMap = ({
  center,
  radius,
  markerPosition,
  geofenceData,
  SendGeofenceData,
}) => {
  const [polygon, setPolygon] = useState(null);
  const [geofence, setGeofence] = useState([]);

  useEffect(() => {
    if (SendGeofenceData?.length) {
      const testData1 = JSON.parse(SendGeofenceData);
      const formattedData = testData1.map((obj) => ({
        lat: obj.lat,
        lng: obj.lng,
      }));
      setGeofence(formattedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const polygonRef = useRef(null);

  // Function to handle when a polygon is drawn
  const onPolygonComplete = (polygonInstance) => {
    if (polygonRef.current) {
      // Remove the existing polygon if one is already drawn
      polygonRef.current.setMap(null);
    }

    const path = polygonInstance
      .getPath()
      .getArray()
      .map((coord) => ({ lat: coord.lat(), lng: coord.lng() }));
    setGeofence(path);
    setPolygon(polygonInstance);
    geofenceData(path);

    // Store the current polygon reference to remove later
    polygonRef.current = polygonInstance;

    // Add click event listener to remove polygon on click
    polygonInstance.addListener("click", () => {
      removePolygon();
    });
  };

  // Function to remove the polygon manually
  const removePolygon = () => {
    if (polygonRef.current) {
      polygonRef.current.setMap(null); // Remove the polygon from the map
      setGeofence([]); // Clear the geofence state
      setPolygon(null); // Reset polygon state
    }
  };

  const location = useLocation();

  return (
    <>
      <div className="relative">
        <GoogleMap
          mapContainerStyle={{
            height: "500px",
            width: "100%",
            marginTop: "20px",
          }}
          zoom={10}
          center={geofence?.[0] || center}
        >
          <DrawingManager
            onPolygonComplete={onPolygonComplete}
            options={{
              drawingControl: true,
              drawingControlOptions: {
                drawingModes: ["polygon"],
              },
              polygonOptions: {
                fillColor: "#2196F3",
                fillOpacity: 0.5,
                strokeWeight: 2,
                clickable: true,
                editable: true,
                zIndex: 1,
              },
            }}
          />
          <Polygon
            paths={geofence}
            options={{
              fillColor: "#2196F3",
              fillOpacity: 0.5,
              strokeColor: "#2196F3",
              strokeOpacity: 1,
              strokeWeight: 2,
              clickable: true,
              editable: true, // Allow user to edit the polygon
              zIndex: 1,
            }}
          />
          {/* <Marker position={markerPosition} /> */}
          <Circle
            center={markerPosition}
            radius={parseFloat(radius) * 1000}
            options={{
              strokeColor: "#73A5C6",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#73A5C6",
              fillOpacity: 0.35,
            }}
          />
        </GoogleMap>
        {polygon && (
          <button
            onClick={removePolygon}
            style={{ marginTop: "10px" }}
            className="absolute top-0 right-16 bg-white border border-gray-300 px-2 py-1 rounded-md"
          >
            Remove Polygon
          </button>
        )}
      </div>
      <div>
        {location.pathname !== "/geofencing" && (
          <h3>
            Geofence Coordinates:{" "}
            {geofence.length > 0
              ? JSON.stringify(geofence)
              : "No geofence drawn"}
          </h3>
        )}
      </div>
    </>
  );
};

export default GeofenceMap;
